// removed by extract-text-webpack-plugin
module.exports = {"header":"_1qRCL","logo":"_2jKwz","user":"_2XvaP","notifications":"_3FaXC","username":"nvPRM","icon":"_3EjPR","confirm":"_1NM2u","logout":"_29m_I"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Header.css
// module id = 549
// module chunks = 0